export class DateFormats {
    public static readonly DEAULT_DATE = 'DD MMM YYYY';
    public static readonly YEAR_MONTH_DAY_DATE_ONLY = 'YYYY/MM/DD';
    public static readonly DATETIME_STANDARD = 'DD MMM YYYY h:mma';
    public static readonly DATETIME_STANDARD_FILE_SAFE = 'DDMMMYYYY-hhmma';
    public static readonly TIMEDATE_STANDARD = 'h:mma DD MMM YYYY';
}
